import React from 'react'
import { Button, Dropdown } from 'antd'
import { MoreOutlined } from '@ant-design/icons'

const ActionButton = ({ content }) => {
	return (
		<Dropdown menu={content}>
			<Button type="text" icon={<MoreOutlined />} />
		</Dropdown>
	)
}

export default ActionButton
